export function status(code) {

  const labels = ['Offline', 'Activated', 'Connected', 'Attached']
  return (typeof code == 'string' || typeof code == 'number') ? labels[parseInt(code)]  : ''
}

export function door(code) {
  const labels = ['Close', 'Open']
  return (typeof code == 'string' || typeof code == 'number') ? labels[parseInt(code)] : ''
}

export function alarm(code) {
  const labels = ['OnAlarm', 'Normal']
  return (typeof code == 'string' || typeof code == 'number') ? labels[parseInt(code)] : ''
}

export function gps(code) {
  const labels = ['Working', 'Not Working']
  return (typeof code == 'string' || typeof code == 'number') ? labels[parseInt(code)] : ''
}

export function onAlarm(item) {
  return item.TAlarm || item.HAlarm || item.DoorAlarm || item.BatteryAlarm || item.CPUAlarm || item.MemoryAlarm || item.GAlarm
}

export function alarmText(item) {
  let text = []
  item.TAlarm && text.push('Temperature Alarm')
  item.HAlarm && text.push('Humidity Alarm')
  item.DoorAlarm && text.push('Door Alarm')
  item.BatteryAlarm && text.push('Battery Alarm')
  item.CPUAlarm && text.push('CPU Alarm')
  item.MemoryAlarm && text.push('Memory Alarm')
  item.GAlarm && text.push('Acceleration alarm')
  return text.join(',')
}

export function isContainer(item) {
  return item.ContainerID && (item.Status == 2 || item.Status ==3)
}

export function isDevice(item) {
  return !isContainer(item)
}



// WEBPACK FOOTER //
// ./src/views/home/convert.js